<template>
    <div class="layout">
        <div class="header">
            <div class="title">
                <div class="title_item" v-for="item in icons" :key="item.id">
                    <div class="flex col middle center" :class="['noChecked', ite.checked ? 'checked' : '']"
                        v-for="ite in item" :key="ite.iconClass" @click="checkedItem(ite)">
                            <div class="icon-wrapper">
                                <i :class="['item', ite.iconClass]"></i>
                                <!-- 消息图标红点提示 -->
                                <div v-if="ite.route === '/talkytimes/message' && totalUnreadCount > 0"
                                    class="message-badge">
                                </div>
                            </div>
                        <span style="font-size: 12px" :class="ite.checked ? 'color-blue3' : 'color-gray2'">
                            {{ ite.title }}
                        </span>
                    </div>
                </div>
                <!-- <div class="title_item" :class="{ 'disabled': isIncomePageActive }"
                    :style="{ cursor: isIncomePageActive ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center' }"
                    @click="goUrl('income')">
                    <i class="el-icon-data-line" style="margin-right: 10px;font-size: 20px;"></i> 查看收益明细
                </div> -->
                <div class="title_item connection-wrapper">
                    <el-button type="primary" size="small" icon="el-icon-paperclip" plain round
                        @click="showSocketDialog = true">
                        v{{ version }} - 账号: {{ connectedCount }}/{{ totalCount }}
                    </el-button>
                    <div @click="logout" class="noChecked">
                        <img class="item" src="@/assets/tc.png" alt="" />
                    </div>
                </div>
            </div>
        </div>

        <keep-alive>
            <router-view />
        </keep-alive>

        <el-dialog title="" :visible.sync="showSocketDialog" width="600px" :close-on-click-modal="false"
            custom-class="socket-dialog" center>
            <div class="socket-dialog-header">
                <div class="dialog-title">
                    <i class="el-icon-connection"></i>
                    <span>用户列表</span>
                    <span class="connection-summary">({{ connectedCount }}/{{ totalCount }})</span>
                </div>
            </div>

            <div class="connection-list">
                <div v-if="filteredConnectionIds.length === 0" class="empty-state">
                    <i class="el-icon-info"></i>
                    <p>暂无用户</p>
                </div>
                <template v-else>
                    <div class="connection-item" v-for="id in filteredConnectionIds" :key="id">
                        <div class="user-avatar" v-if="getUserInfo(id).mfUserDetail?.thumbnailUrl">
                            <img class="w100 h100 round" :src="getUserInfo(id).mfUserDetail?.thumbnailUrl" alt="" />
                        </div>
                        <div v-else class="user-avatar">
                            <i class="el-icon-user"></i>
                        </div>
                        <div class="user-info">
                            <div class="user-name">
                                {{ getUserInfo(id).name || '用户' + id }}
                            </div>
                            <div class="user-id">ID：{{ id }}</div>
                        </div>
                        <div class="connection-status">
                            <div v-if="getConnectionState(id)?.isConnected" class="status-badge connected">
                                <i class="el-icon-success"></i>
                                <span>在线</span>
                            </div>
                            <div v-else class="status-badge disconnected">
                                <i class="el-icon-error"></i>
                                <span>离线</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>

        <!-- 强制更新弹窗 -->
        <el-dialog
            title="版本更新提示"
            :visible.sync="forceUpdateVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :before-close="() => {}"
            width="400px"
            center
            custom-class="force-update-dialog">
            <div style="text-align: center; padding: 20px 0;">
                <i class="el-icon-warning" style="font-size: 48px; color: #E6A23C; margin-bottom: 20px;"></i>
                <p style="font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
                    检测到新版本 <strong>{{ serverVersion }}</strong>，当前版本为 <strong>{{ version }}</strong>
                </p>
                <p style="font-size: 14px; color: #666; margin-bottom: 30px;">
                    必须下载最新版本才能继续使用(最新服务端下载地址：http://moss.ireji.com/appdistribution/pdServer-dev-5.5.3.zip)
                </p>
                <el-button 
                    type="primary" 
                    size="large" 
                    @click="forceDownload"
                    style="padding: 12px 40px; font-size: 16px;">
                    立即下载
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getVersion } from '@/api/user';

export default {
    components: {},
    data() {
        return {
            version: '5.5.3',
            forceUpdateVisible: false, // 强制更新弹窗显示状态
            serverVersion: '', // 服务端版本号
            icons: [
                [
                    // {
                    //     checked: false,
                    //     iconClass: 'el-icon-search',
                    //     route: '/talkytimes/search',
                    //     title: '搜索',
                    // },
                    {
                        checked: false,
                        iconClass: 'el-icon-chat-dot-square',
                        route: '/talkytimes/message',
                        title: '消息',
                    },
                    {
                        checked: false,
                        iconClass: 'el-icon-message',
                        route: '/talkytimes/email',
                        title: '邮件',
                    },
                    {
                        checked: false,
                        iconClass: 'el-icon-chat-line-round',
                        route: '/talkytimes/icebreakers',
                        title: 'icebreakers',
                    },
                    {
                        checked: false,
                        iconClass: 'el-icon-news',
                        route: '/talkytimes/newsFeed',
                        title: 'newsfeed',
                    },
                    {
                        checked: false,
                        iconClass: 'el-icon-shopping-bag-1',
                        route: '/talkytimes/wishList',
                        title: '心愿单',
                    },
                    {
                        checked: false,
                        iconClass: 'el-icon-sold-out',
                        route: '/talkytimes/giftRecord',
                        title: '礼物记录',
                    },
                    // {
                    //     checked: false,
                    //     iconClass: 'el-icon-user',
                    //     route: '/talkytimes/list',
                    //     title: '用户',
                    // },
                    {
                        checked: false,
                        iconClass: 'el-icon-data-line',
                        route: '/talkytimes/income',
                        title: '收益明细',
                    },
                    {
                        checked: false,
                        iconClass: 'el-icon-s-promotion',
                        route: '/talkytimes/masSending',
                        title: '群发',
                    },
                ],
            ],
            navIndex: 0,
            showSocketDialog: false,
        };
    },
    computed: {
        ...mapGetters('socket', [
            'getAllConnectionIds',
            'getConnectionState',
            'getConnectedCount',
            'getUserInfo',
        ]),
        ...mapGetters('accountList', ['getAccountList']),
        showHomeIcon() {
            // 在 /message 路由不显示首页图标
            return this.$route.path !== '/layout/message';
        },
        isIncomePageActive() {
            // 判断当前是否在收益页面
            return this.$route.path === '/talkytimes/income';
        },
        connectedCount() {
            // 过滤掉default连接，只统计真实用户的在线连接数
            return this.filteredConnectionIds.filter(id =>
                this.getConnectionState(id)?.isConnected
            ).length;
        },
        totalCount() {
            return this.filteredConnectionIds.length;
        },
        filteredConnectionIds() {
            return this.getAllConnectionIds.filter(id => id !== 'default');
        },
        totalUnreadCount() {
            const accountList = this.getAccountList || [];
            return accountList.reduce((total, account) => {
                return total + (account.unreadCount || 0);
            }, 0);
        },
    },
    watch: {
        // 监听路由变化，动态更新激活的tab
        $route(to, from) {
            this.initActiveTab();
        },
    },
    methods: {
        handleCommand(v) {
            if (v == 'toFrontEnd') {
                window.open('https://wvviw.lwvvl.com/', '_blank');
                return;
            }

            // 先重置所有图标状态
            this.icons.forEach((item) => {
                item.forEach((ite) => {
                    ite.checked = false;
                });
            });

            switch (v) {
                case '/talkytimes/batchSending':
                    break;
                case '/talkytimes/list':
                    break;
            }

            // 避免重复导航到当前路由
            if (this.$route.path !== v) {
                this.$router.push(v).catch((err) => {
                    // 捕获导航重复错误，避免控制台警告
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        initActiveTab() {
            // 重置所有图标状态
            this.icons.forEach((item) => {
                item.forEach((icon) => {
                    icon.checked = false;
                });
            });

            // 根据当前路由设置激活状态
            const currentPath = this.$route.path;
            this.icons.forEach((item) => {
                item.forEach((icon) => {
                    if (icon.route === currentPath) {
                        icon.checked = true;
                    }
                });
            });
        },
        checkedItem(ite) {
            // 重置所有图标状态
            this.icons.forEach((item) => {
                item.forEach((icon) => {
                    icon.checked = false;
                });
            });

            // 设置当前图标为选中状态
            ite.checked = true;

            // 使用传递的route进行导航
            if (ite.route && this.$route.path !== ite.route) {
                this.$router.push(ite.route).catch((err) => {
                    // 捕获导航重复错误，避免控制台警告
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        async logout() {
            try {
                // 先执行退出登录操作，等待完成
                await this.$store.dispatch('Logout');

                // 在跳转前再次清理缓存，确保没有组件重新设置缓存
                localStorage.clear();
                sessionStorage.clear();

                // 退出登录完成后，再进行路由跳转
                this.$router.replace('/login');
            } catch (error) {
                console.error('退出登录失败:', error);
                // 即使失败也要清理缓存并跳转到登录页
                localStorage.clear();
                sessionStorage.clear();
                this.$router.replace('/login');
            }
        },
        goUrl(v) {
            console.log(v, 'v');
            if (v == 'jj') {
                this.$router.push('/talkytimes/list');
            } else if (v == 'income') {
                // 如果已经在收益页面，则不执行跳转
                if (this.isIncomePageActive) {
                    return;
                }
                this.$router.push('/talkytimes/income');
            }
        },
        disconnect(id) {
            this.$store.dispatch('socket/closeConnection', id);
        },
        // 检查服务端版本
        checkVersion() {
            getVersion().then(res => {
                console.log(res, '服务端版本信息');
                if (res.code === 200 && res.data) {
                    const serverVersion = res.data.version || res.data;
                    console.log('服务端版本:', serverVersion, '前端版本:', this.version);
                    
                    // 比较版本号
                    if (serverVersion !== this.version) {
                        this.serverVersion = serverVersion;
                        this.forceUpdateVisible = true;
                    }
                } else {
                    this.forceUpdateVisible = true;
                }
            }).catch(err => {
                console.error('获取服务端版本失败:', err);
            });
        },
        
        // 强制下载
        forceDownload() {
            // 打开下载链接
            window.open('http://moss.ireji.com/appdistribution/pdServer-dev-5.5.3.zip', '_blank');
            // 不关闭弹窗，保持显示状态
        },
        
        // 页面获得焦点时
        onWindowFocus() {
            // 如果版本不匹配且弹窗未显示，重新显示弹窗
            if (this.serverVersion && this.serverVersion !== this.version && !this.forceUpdateVisible) {
                this.forceUpdateVisible = true;
            }
        },
    },
    created() { },
    mounted() {
        this.initActiveTab();
        
        // 检查服务端版本
        this.checkVersion();
        
        // 监听页面焦点变化，确保从下载页面返回后弹窗仍然显示
        window.addEventListener('focus', this.onWindowFocus);

        // 检查并显示更新通知
        console.log(this.$root.checkUpdateNotice, 'this.$root.checkUpdateNotice');
        if (this.$root.checkUpdateNotice) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$root.checkUpdateNotice();
                }, 500);
            });
        }
    },
    beforeDestroy() {
        // 清理事件监听器
        window.removeEventListener('focus', this.onWindowFocus);
    },
};
</script>
<style lang="scss" scoped>
// @import '@/style.scss';
@use '@/style.scss' as *;

.layout {
    width: 100%;
    min-height: 100vh;
    background-color: $definedColorG;
    box-sizing: border-box;
    padding: 0 28px;
    display: flex;
    flex-direction: column;

    .header {
        width: 100%;
        height: 56px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .title {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            height: 100%;
            padding: 0 30px;

            .title_item {
                display: flex;
                height: 100%;
                position: relative;

                &.disabled {
                    opacity: 0.5;
                    color: #ccc;

                    i {
                        color: #ccc;
                    }
                }

                .noChecked {
                    position: relative;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    .item {
                        padding: 0 22px 4px;
                        font-size: 20px;
                        color: #666;
                        transition: color 0.3s ease;

                        &.el-icon-chat-dot-square,
                        &.el-icon-message {
                            color: #666;
                        }
                    }

                    &.checked {
                        .item {
                            color: #409eff;

                            &.el-icon-chat-dot-square,
                            &.el-icon-message {
                                color: #409eff;
                            }
                        }
                    }

                    &.checked::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 5px;
                        background-color: #409eff;
                        border-radius: 3px;
                    }
                }

                &.connection-wrapper {
                    height: auto;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
}

.funtionBox {
    background: #fff;
    padding: 12px 20px;
    border-radius: 8px;
    margin: 4px 8px;
    transition: all 0.3s ease;
    border: 1px solid transparent;
    position: relative;
    overflow: hidden;

    &:hover {
        background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
        border-color: #e1e8ff;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
    }

    .row {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 14px;
        color: #2c3e50;
        line-height: 1.4;
        text-align: left;
        font-style: normal;
        text-transform: none;
        position: relative;
        z-index: 1;

        img,
        i {
            width: 18px;
            height: 18px;
            margin-right: 12px;
            transition: all 0.3s ease;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        i {
            width: auto;
            height: auto;
        }

        span {
            font-weight: 500;
            letter-spacing: 0.3px;
        }
    }

    &:hover .row img,
    &:hover .row i {
        transform: scale(1.1);
    }

    &:nth-child(1) {
        margin-bottom: 8px;
    }

    // 为不同菜单项添加不同的颜色主题
    &:nth-child(1) {
        .row {
            color: #409eff;

            i {
                color: #409eff;
            }
        }

        &:hover {
            background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
            border-color: #b3d8ff;
        }
    }

    &:nth-child(2) {
        .row {
            color: #67c23a;

            i {
                color: #67c23a;
            }
        }

        &:hover {
            background: linear-gradient(135deg, #f0f9eb 0%, #e7f6d7 100%);
            border-color: #c2e7b0;
        }
    }

    &:nth-child(3) {
        .row {
            color: #e6a23c;

            i {
                color: #e6a23c;
            }
        }

        &:hover {
            background: linear-gradient(135deg, #fdf6ec 0%, #f5e6d3 100%);
            border-color: #f5dab1;
        }
    }

    &:nth-child(4) {
        .row {
            color: #f56c6c;

            i {
                color: #f56c6c;
            }
        }

        &:hover {
            background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
            border-color: #fbc4c4;
        }
    }
}

// 优化下拉菜单容器样式
:deep(.funtionMenu) {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    border: 1px solid #e8eaed;
    padding: 8px 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    min-width: 180px;
    animation: dropdownFadeIn 0.3s ease-out;

    .el-dropdown-menu__item {
        padding: 0;
        margin: 0;
        border-radius: 0;

        &:hover {
            background-color: transparent;
        }

        &:focus {
            background-color: transparent;
        }
    }
}

// 下拉菜单动画
@keyframes dropdownFadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

// 分隔线样式
.dropdown-divider {
    height: 1px;
    background: linear-gradient(90deg,
            transparent 0%,
            #e8eaed 20%,
            #e8eaed 80%,
            transparent 100%);
    margin: 8px 16px;
    opacity: 0.6;
}

// 优化下拉菜单触发按钮样式
.dropdown {
    .item {
        transition: all 0.3s ease;
        border-radius: 6px;
        padding: 4px;

        &:hover {
            transform: scale(1.05);
            filter: brightness(1.1);
        }
    }
}

:deep(.el-dialog__close) {
    // color: #fff !important;
}

// WebSocket连接弹窗样式
:deep(.socket-dialog) {
    border-radius: 16px;
    overflow: hidden;

    .el-dialog__header {
        padding: 0;
        border-bottom: none;
    }

    .el-dialog__body {
        padding: 0;
    }

    .el-dialog__footer {
        padding: 20px 24px;
        border-top: 1px solid #f0f0f0;
        background: #fafafa;
    }
}

.socket-dialog-header {
    padding: 24px 24px 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;

    .dialog-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;

        i {
            font-size: 20px;
            margin-right: 8px;
        }

        .connection-summary {
            margin-left: 8px;
            font-size: 14px;
            font-weight: 400;
            opacity: 0.8;
        }
    }
}

.connection-list {
    padding: 20px 24px;
    max-height: 400px;
    overflow-y: auto;

    .empty-state {
        text-align: center;
        padding: 40px 20px;
        color: #999;

        i {
            font-size: 48px;
            margin-bottom: 16px;
            color: #ddd;
        }

        p {
            font-size: 16px;
            margin: 0;
        }
    }

    .connection-item {
        display: flex;
        align-items: center;
        padding: 16px 20px;
        margin-bottom: 12px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #f0f0f0;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            transform: translateY(-1px);
        }

        &:last-child {
            margin-bottom: 0;
        }

        .user-avatar {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: linear-gradient(135deg, #667eea, #764ba2);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;

            i {
                font-size: 20px;
                color: white;
            }
        }

        .user-info {
            flex: 1;

            .user-name {
                font-size: 16px;
                font-weight: 600;
                color: #333;
                margin-bottom: 4px;
            }

            .user-id {
                font-size: 12px;
                color: #999;
                font-family: 'Courier New', monospace;
            }
        }

        .connection-status {
            margin-right: 16px;

            .status-badge {
                display: flex;
                align-items: center;
                padding: 6px 12px;
                border-radius: 20px;
                font-size: 12px;
                font-weight: 500;

                i {
                    font-size: 14px;
                    margin-right: 4px;
                }

                &.connected {
                    background: #f0f9ff;
                    color: #10b981;
                    border: 1px solid #d1fae5;

                    i {
                        color: #10b981;
                    }
                }

                &.disconnected {
                    background: #fef2f2;
                    color: #ef4444;
                    border: 1px solid #fecaca;

                    i {
                        color: #ef4444;
                    }
                }
            }
        }

        .action-buttons {

            .disconnect-btn,
            .connect-btn {
                font-size: 12px;
                padding: 8px 16px;

                i {
                    font-size: 12px;
                    margin-right: 4px;
                }
            }

            .disconnect-btn {
                border-color: #ef4444;
                color: #ef4444;

                &:hover {
                    background: #ef4444;
                    color: white;
                }
            }

            .connect-btn {
                color: #409eff;
                background: #ecf5ff;
                border-color: #b3d8ff;

                &:hover {
                    color: #fff;
                    background: #409eff;
                    border-color: #409eff;
                }
            }

            .test-connect-btn {
                border-color: #c2e7b0;
                background: #f0f9eb;
                color: #67c23a;

                &:hover {
                    color: #fff;
                    background: #67c23a;
                    border-color: #67c23a;
                }
            }
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .el-button {
        padding: 10px 20px;
        font-weight: 500;

        &.el-button--primary {
            background: linear-gradient(135deg, #667eea, #764ba2);
            border: none;

            &:hover {
                background: linear-gradient(135deg, #5a67d8, #6b46c1);
            }
        }
    }
}

// 邮件badge样式
.email-badge {
    :deep(.el-badge__content) {
        background-color: #f56c6c;
        border: none;
        font-size: 10px;
        font-weight: 600;
        min-width: 12px;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(245, 108, 108, 0.3);
    }

    :deep(.el-badge__content.is-fixed) {
        top: 2px;
        right: 20px;
    }
}

// 消息气泡样式
.icon-wrapper {
    position: relative;
    display: inline-block;

    .message-badge {
        position: absolute;
        top: -4px;
        right: -2px;
        width: 10px;
        height: 10px;
        background: #ff3b30;
        border-radius: 50%;
        box-shadow: 0 0 0 2px #fff;
        animation: badgePulse 2s infinite;
        z-index: 10;
    }
}

// 气泡脉冲动画
@keyframes badgePulse {
    0% {
        transform: scale(1);
        box-shadow: 0 2px 6px rgba(255, 71, 87, 0.4);
    }

    50% {
        transform: scale(1.1);
        box-shadow: 0 4px 12px rgba(255, 71, 87, 0.6);
    }

    100% {
        transform: scale(1);
        box-shadow: 0 2px 6px rgba(255, 71, 87, 0.4);
    }
}

// 强制更新弹窗样式
:deep(.force-update-dialog) {
    z-index: 9999 !important;
    border-radius: 8px !important;

    .el-dialog__header {
        background-color: #f5f7fa !important;
        border-bottom: 1px solid #e4e7ed !important;
    }

    .el-dialog__title {
        font-weight: bold !important;
        color: #303133 !important;
    }

    .el-dialog__close {
        display: none !important;
    }
}
</style>
